import translations, { BASE_LANGUAGE, Translations } from '@locales/index';
import i18n from 'i18next';
// eslint-disable-next-line no-restricted-imports
import { initReactI18next, useTranslation as useI18nTranslations } from 'react-i18next';
import { addI18nFormatters } from './i18n.utils';

export { i18n }; // NOSONAR - i18n is used locally
// Re-exported so app.providers mounts the tree without reaching for react-i18next itself,
// keeping this file the only door to the library.
// eslint-disable-next-line no-restricted-imports
export { I18nextProvider } from 'react-i18next';

// Single entry point to i18next's `TFunction` for the rest of the frontend, so the
// signatures that take a translate function do not each reach for the library.
// Importing it straight from 'i18next' is banned by no-restricted-imports; this file
// is the one place allowed to.
// eslint-disable-next-line no-restricted-imports
export type { TFunction } from 'i18next';
// The call sites that cannot use the `useTranslation` hook -- validations, business and
// utils modules -- take `t` from here rather than from the library.
// eslint-disable-next-line no-restricted-imports
export { t } from 'i18next';

export const i18nProvider = (userLanguage: string, userLanguageTranslations?: Translations) => {
    i18n.use(initReactI18next).init({
        resources: userLanguageTranslations
            ? { ...translations, [userLanguage]: { translation: userLanguageTranslations } }
            : translations,
        lng: userLanguage,
        fallbackLng: BASE_LANGUAGE,
        interpolation: {
            escapeValue: false,
        },
        returnEmptyString: false,
    });
    addI18nFormatters(i18n);
};

export const useTranslation = () => {
    const { t, i18n: i18nTranslation } = useI18nTranslations();
    return { t, i18n: i18nTranslation };
};

export const getI18nCodeLanguage = (lang: string): string => {
    const langRegion: string[] = lang.split('_').map((c) => c.toLocaleUpperCase());
    return langRegion.every((c) => c === langRegion[0]) ? langRegion[0] : langRegion.join('-');
};
